"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ByElection = void 0;
const Tags_1 = require("../../Tags");
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const SelectOption_1 = require("../../../inputs/SelectOption");
const OrOptions_1 = require("../../../inputs/OrOptions");
const DeferredAction_1 = require("../../../deferredActions/DeferredAction");
const CardRenderer_1 = require("../../render/CardRenderer");
const Size_1 = require("../../render/Size");
const PoliticalAgendas_1 = require("../../../turmoil/PoliticalAgendas");
const Turmoil_1 = require("../../../turmoil/Turmoil");
class ByElection extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.BY_ELECTION,
            tags: [Tags_1.Tags.WILDCARD],
            metadata: {
                cardNumber: 'Y02',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.text('set ruling party', Size_1.Size.SMALL, true).br;
                    b.plus().influence(1);
                }),
                description: 'Set the ruling party to one of your choice. Gain 1 influence.',
            },
        });
    }
    play(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        turmoil.addInfluenceBonus(player);
        const setRulingParty = new OrOptions_1.OrOptions();
        setRulingParty.title = 'Select new ruling party';
        setRulingParty.options = [...turmoil.parties.map((p) => new SelectOption_1.SelectOption(p.name, 'Select', () => {
                turmoil.rulingParty = turmoil.getPartyByName(p.name);
                PoliticalAgendas_1.PoliticalAgendas.setNextAgenda(turmoil, player.game);
                return undefined;
            }))];
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => setRulingParty));
        return undefined;
    }
}
exports.ByElection = ByElection;
//# sourceMappingURL=ByElection.js.map